import { c as _c } from "react/compiler-runtime";
import { HotelCityTitle } from "@website/accommodation-ui/hotel-list-header/hotel-city-title";
import { HotelListHeaderPropertiesType } from "@website/accommodation-ui/hotel-list-header/hotel-list-header.types";
import { HotelSortView } from "@website/accommodation-ui/hotel-list-header/hotel-sort-view";
import { MaterialIcon } from "@website/icons/material";
import { getTracking } from "@website/store/tracking";
import { Button } from "@website/ui/button";
import { Switch } from "@website/ui/switch";
import { deepOmit } from "@website/utils/deep-omit";
import { isFilled } from "@website/utils/is-filled";
import { numberConvert } from "@website/utils/number-convert";
import { HotelFilterChips } from "@website/widget/filter";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { FC } from "react";
export const HotelListHeader: FC<HotelListHeaderPropertiesType> = properties => {
  const $ = _c(29);
  const router = useRouter();
  const {
    loading,
    isFilterFetching,
    totalItem,
    city,
    sortProperties,
    selectedFiltersCount,
    setFilterOpen,
    hasFilter: t0,
    hasCityPrefix: t1,
    children,
    chipsFiltersSchema,
    hasCityNearby,
    isSticky: t2,
    isStickyPositioned: t3,
    stripTriggerInView,
    showStripLoadingSkeleton,
    shouldAnimateStripItems,
    isNewPlP
  } = properties;
  const hasFilter = t0 === undefined ? true : t0;
  const hasCityPrefix = t1 === undefined ? true : t1;
  const isSticky = t2 === undefined ? false : t2;
  const isStickyPositioned = t3 === undefined ? true : t3;
  const t4 = selectedFiltersCount ? "secondary" as const : "neutral" as const;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <MaterialIcon className="text-sm" name="tune" />;
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  let t6;
  if ($[1] !== router || $[2] !== selectedFiltersCount) {
    t6 = selectedFiltersCount ? `فیلترها (${numberConvert(selectedFiltersCount, {
      locale: router.locale
    })})` : "\u0641\u06CC\u0644\u062A\u0631\u0647\u0627";
    $[1] = router;
    $[2] = selectedFiltersCount;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== setFilterOpen || $[5] !== t4 || $[6] !== t6) {
    t7 = {
      variant: "round-outline" as const,
      color: t4,
      size: "small" as const,
      StartIcon: t5,
      children: t6,
      onClick: setFilterOpen
    };
    $[4] = setFilterOpen;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const buttonProperties = t7;
  let t8;
  if ($[8] !== buttonProperties || $[9] !== children || $[10] !== chipsFiltersSchema || $[11] !== city || $[12] !== hasCityNearby || $[13] !== hasCityPrefix || $[14] !== hasFilter || $[15] !== isFilterFetching || $[16] !== isNewPlP || $[17] !== isSticky || $[18] !== isStickyPositioned || $[19] !== loading || $[20] !== router || $[21] !== selectedFiltersCount || $[22] !== setFilterOpen || $[23] !== shouldAnimateStripItems || $[24] !== showStripLoadingSkeleton || $[25] !== sortProperties || $[26] !== stripTriggerInView || $[27] !== totalItem) {
    t8 = <>{isSticky ? <div className={`border-outline-thin bg-on-color-high-emphasis z-[9] w-full overflow-auto border-y py-2 pl-0 pr-5 md:border-t-0 md:pt-1 lg:overflow-visible lg:bg-white lg:px-3 xl:px-0 ${isStickyPositioned ? "sticky top-[72px]" : ""}`}><div className="flex w-full flex-wrap items-center justify-between gap-2 xl:mx-auto xl:max-w-[1200px]"><div className="flex min-w-0 flex-1 justify-start gap-2">{children}{chipsFiltersSchema && <HotelFilterChips loading={isFilterFetching} hasFilter={hasFilter} isNewPlP={isNewPlP} classname="min-w-0 flex-1" setFilterOpen={setFilterOpen} chipsFiltersSchema={chipsFiltersSchema} showStripLoadingSkeleton={showStripLoadingSkeleton} stripTriggerInView={stripTriggerInView} shouldAnimateStripItems={shouldAnimateStripItems} selectedFiltersCount={selectedFiltersCount} deferRangeUpdates={false} />}</div></div></div> : <div className="lg:border-outline-thin bg-on-color-high-emphasis -mx-6 flex flex-wrap items-center justify-between gap-2 overflow-auto border border-b-0 p-3 px-5 lg:m-0 lg:overflow-visible lg:rounded-lg lg:border-b lg:bg-transparent lg:px-3"><div className="-mt-5 hidden lg:mt-0 lg:block"><HotelCityTitle isNewPlP={isNewPlP} city={city} hasCityPrefix={hasCityPrefix} loading={loading} totalItem={totalItem} /></div><div className="flex justify-start gap-2">{hasCityNearby && getTracking()?.experiment?.experiment_nearby_cities_toggle === "true" && <Switch key={`nearby=${router.query?.nearby}`} name="nearby" label={"\u0646\u0645\u0627\u06CC\u0634 \u0648\u06CC\u0644\u0627\u0647\u0627\u06CC \u0627\u0637\u0631\u0627\u0641"} checked={Boolean(router.query?.nearby)} onChange={() => router.replace({
            query: deepOmit({
              ...omit(router.query, ["geo_property_summary"]),
              nearby: !router.query?.nearby || undefined
            }, isFilled)
          }, undefined, {
            shallow: true,
            scroll: false
          })} color="secondary" className="!text-body-2 !hidden flex-row-reverse !items-center !p-0 lg:!flex" />}{hasFilter && <div className="xl:hidden"><Button className="!whitespace-nowrap" {...buttonProperties} /></div>}<HotelSortView {...sortProperties} isNewPlP={isNewPlP} />{children}{chipsFiltersSchema && <HotelFilterChips loading={isFilterFetching} chipsFiltersSchema={chipsFiltersSchema} showStripLoadingSkeleton={showStripLoadingSkeleton} isNewPlP={isNewPlP} classname={`${isNewPlP ? "md:block" : "md:!hidden"} block`} deferRangeUpdates={false} />}</div></div>}</>;
    $[8] = buttonProperties;
    $[9] = children;
    $[10] = chipsFiltersSchema;
    $[11] = city;
    $[12] = hasCityNearby;
    $[13] = hasCityPrefix;
    $[14] = hasFilter;
    $[15] = isFilterFetching;
    $[16] = isNewPlP;
    $[17] = isSticky;
    $[18] = isStickyPositioned;
    $[19] = loading;
    $[20] = router;
    $[21] = selectedFiltersCount;
    $[22] = setFilterOpen;
    $[23] = shouldAnimateStripItems;
    $[24] = showStripLoadingSkeleton;
    $[25] = sortProperties;
    $[26] = stripTriggerInView;
    $[27] = totalItem;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};